import TextStyle from '../../../../../styles/text';

export default {
    btnCustom: {
        textTransform: 'none',
    },
    btnCustomDisable: {
        textTransform: 'none',
        marginLeft: '15px',
        marginBottom: '15px',
        color: '#f04540',
        textDecoration: 'none',
        fontSize: '13px',
        padding: '0',
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        fontWeight: '400',
    },
    btnCustomCancel: {
        textTransform: 'none',
        backgroundColor: '#989b9c',
    },
    titleDialogStyle: {
        display: 'block',
        padding: '30px 30px 40px 30px',
        fontSize: '18px',
        color: '#000000',
        fontWeight: 500,
        borderBottom: '0',
    },
    bodyDialogStyle: {
        ...TextStyle.text_md,
        paddingLeft: '30px',
        paddingRight: '30px',
    },
    checkbox: {
        ...TextStyle.text_md,
        display: 'inline-block',
    },
    scrollContent: {
        minHeight: '185px',
        maxHeight: '300px',
        width: '681px',
        borderLeft: '1px solid rgb(221, 221, 221)',
        borderRight: '1px solid rgb(221, 221, 221)',
        borderBottom: '1px solid rgb(221, 221, 221)',
    },
};
